@if (lastSizesIds$ | async; as lastSizesArray) {
    @if (lastSizesArray.length > 0) {
        <div>
            <div class="title-l-b ttu is-flex content-center pt-64">{{ 'dev.category.lastSizes' | translate }}</div>
            <div class="grid-product-wrap pt-48">
                <ul class="grid-product-list grid-product-list-{{ gridType }}">
                    @for (productId of lastSizesArray; track $index; let indexOfElement = $index) {
                        <li class="grid-product grid-product-view{{ gridType }} sk-load{{ gridType }}">
                            <product-view
                                class="full-size p-view"
                                [productId]="productId"
                                [categoryConfig]="categoryConfiguration"
                                [config]="templateConfiguration"
                                [elementIndex]="indexOfElement"
                                [defaultImageType]="defaultImageTypes?.[productId]"
                            ></product-view>
                        </li>
                    }
                </ul>
            </div>
        </div>
    }
}
